// Models
import { Campaign } from 'models/Campaign'
import { StudioCampaign } from 'models/StudioCampaign'
import { getCampaign } from 'redux/services/campaign'

// Redux services
import { getLegacyCampaign } from 'redux/services/campaign/legacy'
import { getOrganizationDesignations } from 'redux/services/designation'

// Local
import { RootState, TypedDispatch } from 'redux/store'
import { FinalizeOrderArgs } from '../types'

/**
 * Updates the transaction with designation information.
 * @param cid - Campaign ID
 * @param transaction - Transaction details
 */
const getDesignationId = async (
  store: RootState,
  dispatch: TypedDispatch<RootState>,
  args: FinalizeOrderArgs,
): Promise<number | undefined> => {
  // If a donor has selected a designation manually, go with that
  if (store.order.donationOptions.designationId) {
    return store.order.donationOptions.designationId
  }

  // Revenue Location Code Mapping
  // For orgs with this enabled (Salvation Army), we find a matching designation based on the donor's zipcode
  const studioCampaign: StudioCampaign = await dispatch(getCampaign.initiate(args.cid)).unwrap()

  if (studioCampaign.checkout?.revenue_location_code?.enabled) {
    const postalCode = store.order.billingDetails.address.postalCode

    if (!!postalCode) {
      // Always use only the first 5 digits of the postal code for matching
      const truncatedPostalCode = postalCode.substring(0, 5)

      const orgDesignations = await dispatch(
        getOrganizationDesignations.initiate({
          organizationId: args.oid,
          params: { filter: `postal_code=${truncatedPostalCode}` },
        }),
      ).unwrap()

      // If the default organization is returned by the list of the organization designations
      // for some reason, we want to make sure we use the other one in the list.
      const designationOverride = orgDesignations.data.find(
        (designation) => !designation.is_default,
      )

      // Return the designation id if a match is found
      if (designationOverride) {
        return designationOverride.id
      }
    }
  }

  // Otherwise, default to the campaign's default designation
  const campaign: Campaign = await dispatch(getLegacyCampaign.initiate(args.cid)).unwrap()

  return campaign.designation_id
}

export default getDesignationId
